import QuizIncService from "@/services/quizIncService";

export async function getSessionId(msisdn) {
    if (localStorage.getItem('sessionId')) return localStorage.getItem('sessionId');
    const {sessionId} = await QuizIncService.createSessionId(msisdn);
    localStorage.setItem('sessionId', sessionId);
    return sessionId;
}